import url from 'url';
import { createContext } from 'react';
import PropTypes from 'prop-types';
import format from 'string-format';
import parseQuery from 'src/common/utils/queryString/parse';

const LocationAndLocalizationContext = createContext();
LocationAndLocalizationContext.displayName = 'LocationAndLocalizationProvider';

const LocationAndLocalizationProvider = ({
  locale = '',
  location = {},
  localizations = {},
  children,
}) => {
  const locationObj =
    (location.pathname !== undefined && url.parse(location.pathname)) || null;
  const query = parseQuery(location.search);

  const getLocalizedText = (name, values) => {
    let text = localizations[name];
    // eslint-disable-next-line no-console
    if (!text) console.warn(`'${name}' is not defined in translations.`);

    if (text && values) {
      text = format(text, values);
    }

    return text || name;
  };

  const value = {
    locale,
    location: {
      ...locationObj,
      query,
      search: location.search,
      state: location.state,
    },
    getLocalizedText,
  };

  return (
    <LocationAndLocalizationContext.Provider value={value}>
      {children}
    </LocationAndLocalizationContext.Provider>
  );
};

LocationAndLocalizationProvider.propTypes = {
  locale: PropTypes.string,
  location: PropTypes.object,
  localizations: PropTypes.object,
  children: PropTypes.node.isRequired,
};

export default LocationAndLocalizationProvider;
export { LocationAndLocalizationContext };
